import React from 'react';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import { DATE_FORMAT } from '../../../constants/session';
import appConfig from '../../../appConfig';

const DateInput = ({
  id,
  handleInputChange,
  metaTag,
  fileIndex,
  tagIndex,
  userInput,
}) => {
  const dateFormat = appConfig.dateFormat || DATE_FORMAT;
  return (
    <DatePicker
      isClearable
      className="form-control"
      id={metaTag.meta.id}
      key={id}
      value={userInput}
      onChange={date =>
        handleInputChange(fileIndex, tagIndex, format(date, dateFormat))}
      placeholderText={(dateFormat).toLocaleLowerCase()}
      dateFormat={dateFormat}
    />
  );
};

export default DateInput;
